// extracted by mini-css-extract-plugin
export var dropdown = "_fl-0";
export var imagePlaceholder = "_fl-2";
export var imageWrapper = "_fl-3";
export var productImage = "_fl-1";
export var truncateContainer = "_fl-4";
export var truncateText = "_fl-5";